module.exports = __webpack_public_path__ + "img/icon-close-green.c590d143.svg";